module.exports = __webpack_public_path__ + "img/virtual-low.f602436d.jpg";